import { CSSProperties } from 'react'

import editIcon from '@assets/images/project-settings-pen-icon.svg'
import trashIcon from '@assets/images/project-settings-trash-icon.svg'

import taskWorkforceIcon from '@assets/images/task-workforce-icon.svg'
import taskDurationIcon from '@assets/images/task-duration-icon.svg'

import { TaskTemplate } from '@types'

import { TradeTag } from '@modules/_shared/components/TradeTag'

import { SequenceTaskTemplatePlanningType } from '../SequenceTemplatePlanning'

import {
  ActionIconImg,
  BodyContainer,
  Container,
  HeaderContainer,
  IconImg,
  LabelCompany,
  LabelTaskTemplate,
  SummaryContainer,
  ValueContainer,
  ValueLabel,
} from './TaskTemplateThumb.styled'

interface Props {
  task: TaskTemplate | SequenceTaskTemplatePlanningType
  view?: 'list' | 'calendar' | 'tooltip'
  style?: CSSProperties
  onClickEdit?: () => void
  onClickDelete?: () => void
  isDragging?: boolean
}

export const TaskTemplateThumb = (props: Props): JSX.Element => {
  const {
    task: { name, trade, workforce, duration, company },
    view = 'list',
    style,
    onClickEdit,
    onClickDelete,
    isDragging,
  } = props

  return (
    <Container style={style} backgroundColor={trade.color} className={view} isDragging={isDragging}>
      <HeaderContainer>
        <LabelTaskTemplate color={trade.color || 'black'}>{name}</LabelTaskTemplate>

        {onClickEdit && <ActionIconImg src={editIcon} onClick={onClickEdit} />}
        {onClickDelete && <ActionIconImg src={trashIcon} onClick={onClickDelete} />}
      </HeaderContainer>

      <BodyContainer>
        <TradeTag trade={trade} />
        <LabelCompany>{company?.name}</LabelCompany>

        {(view == 'list' || (view == 'calendar' && duration >= 2)) && (
          <SummaryContainer>
            <ValueContainer>
              <IconImg src={taskWorkforceIcon} />
              <ValueLabel>{workforce}</ValueLabel>
            </ValueContainer>

            <ValueContainer>
              <IconImg src={taskDurationIcon} />
              <ValueLabel>{duration}</ValueLabel>
            </ValueContainer>
          </SummaryContainer>
        )}
      </BodyContainer>

      {view == 'tooltip' && (
        <SummaryContainer>
          <ValueContainer>
            <IconImg src={taskWorkforceIcon} />
            <ValueLabel>{workforce}</ValueLabel>
          </ValueContainer>

          <ValueContainer>
            <IconImg src={taskDurationIcon} />
            <ValueLabel>{duration}</ValueLabel>
          </ValueContainer>
        </SummaryContainer>
      )}
    </Container>
  )
}
